export default __webpack_public_path__ + "static/partnerIcon9-5984712f2caf41930ca60930ae2b02b7.svg";